import * as React from "react";
import type { SVGProps } from "react";
const SvgPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pinterest_svg__a)">
      <path d="M8 21a1.002 1.002 0 0 1-.91-1.41l4-9a.998.998 0 0 1 1.674-.32 1 1 0 0 1 .146 1.14l-4 9A1 1 0 0 1 8 21" />
      <path d="M13.25 17a3.71 3.71 0 0 1-3.5-2.67 1.006 1.006 0 1 1 1.9-.66 1.74 1.74 0 0 0 1.6 1.33A2.76 2.76 0 0 0 16 12a4 4 0 0 0-2.469-3.697 4 4 0 0 0-3.38.149A4 4 0 0 0 8.24 13.37a1 1 0 1 1-1.88.63A6 6 0 0 1 12 6a6 6 0 0 1 6 6 4.72 4.72 0 0 1-4.75 5" />
      <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16" />
    </g>
    <defs>
      <clipPath id="pinterest_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPinterest;
